export default "__VITE_ASSET__dEo_xHb0__"